export default "__VITE_ASSET__DC8Jrbn5__"